import { render, staticRenderFns } from "./mapPersonList.vue?vue&type=template&id=1852f12a&scoped=true"
import script from "./mapPersonList.vue?vue&type=script&lang=js"
export * from "./mapPersonList.vue?vue&type=script&lang=js"
import style0 from "./mapPersonList.vue?vue&type=style&index=0&id=1852f12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852f12a",
  null
  
)

export default component.exports